/** Browser IANA timezone, falls back to UTC. */
export function getBrowserTimezone(): string {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    } catch {
        return 'UTC';
    }
}

/** e.g. "America/Chicago (GMT-5)" */
export function formatTimezoneOptionLabel(tz: string): string {
    const zone = tz?.trim() || 'UTC';
    try {
        const offset =
            new Intl.DateTimeFormat('en-US', {
                timeZone: zone,
                timeZoneName: 'shortOffset',
            })
                .formatToParts(new Date())
                .find(p => p.type === 'timeZoneName')?.value || '';
        return offset ? `${zone} (${offset})` : zone;
    } catch {
        return zone;
    }
}

const FALLBACK_TIMEZONES = [
    'UTC',
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Toronto',
    'America/Mexico_City',
    'America/Sao_Paulo',
    'Europe/London',
    'Europe/Paris',
    'Europe/Berlin',
    'Europe/Madrid',
    'Africa/Lagos',
    'Africa/Johannesburg',
    'Africa/Cairo',
    'Asia/Dubai',
    'Asia/Kolkata',
    'Asia/Singapore',
    'Asia/Tokyo',
    'Asia/Shanghai',
    'Australia/Sydney',
    'Pacific/Auckland',
];

/** IANA zones for a select: preferred + local first, then full list. */
export function listTimezoneOptions(preferred?: string): string[] {
    let zones: string[] = FALLBACK_TIMEZONES;
    try {
        const supported = (Intl as any).supportedValuesOf?.('timeZone');
        if (Array.isArray(supported) && supported.length) {
            zones = supported as string[];
        }
    } catch {
        /* keep fallback */
    }
    const local = getBrowserTimezone();
    const preferredZone = preferred || local;
    const rest = zones.filter(z => z !== preferredZone && z !== local);
    const head = preferredZone === local ? [local] : [preferredZone, local].filter(Boolean);
    return [...head, ...rest];
}
